module.exports = __webpack_public_path__ + "e6ad5e3deaa7b605222ed2b7d5702ef9.png";